<template>
    <b-modal
        hide-footer
        id="info-tire-type"
        title="Tire Type"
        v-model="visible"
        size="md"
    >
        <p>Choose metric standard, IF or VF technology tires.</p>
    </b-modal>
</template>

<script>
export default {
    data: () => ({
        visible: false,
    }),
}
</script>
